export default __webpack_public_path__ + "static/media/schedule_for_route_sample.46bf4928.png";